import type { ManagementTranslations } from '../en-US/management.translations';

export const managementTranslations: ManagementTranslations = {
  title: 'Gestione BiteCritic',
  dashboard: 'Dashboard',
  users: 'Gestione Utenti',
  settings: 'Impostazioni',
  foods: {
    title: 'Gestione Alimenti',
    createNew: 'Aggiungi Nuovo Alimento',
    id: 'ID',
    name: 'Nome',
    category: 'Categoria',
    country: 'Paese',
    status: 'Stato',
    createdAt: 'Creato il',
    actions: 'Azioni',
    noFoodsFound: 'Nessun alimento trovato',
    searchPlaceholder: 'Cerca alimenti...',
    allStatuses: 'Tutti gli Stati',
    allCategories: 'Tutte le Categorie',
    sortNewest: 'Più Recenti Prima',
    sortOldest: 'Più Vecchi Prima',
    sortNameAZ: 'Nome A-Z',
    sortNameZA: 'Nome Z-A',
    showing: 'Visualizzazione da {{from}} a {{to}} di {{total}} alimenti',
    confirmDelete: 'Sei sicuro di voler eliminare questo alimento?',
    approve: 'Approva',
    reject: 'Rifiuta',
    createFood: 'Crea Nuovo Alimento',
    editFood: 'Modifica Alimento',
    viewFood: 'Visualizza Dettagli Alimento',
    namePlaceholder: "Inserisci nome dell'alimento",
    descriptionPlaceholder: "Inserisci descrizione dell'alimento",
    selectCategory: 'Seleziona una categoria',
    selectCountry: 'Seleziona un paese',
    selectStatus: 'Seleziona uno stato',
    imageUrl: "URL dell'immagine",
    imageUrlPlaceholder: "Inserisci URL dell'immagine",
    imagePreview: 'Anteprima immagine',
    rowsPerPage: '{{count}} per pagina',
    translations: 'Traduzioni',
    description: 'Descrizione',
    formatJson: 'Formatta JSON',
    jsonPlaceholder: "Inserisci dati dell'alimento in formato JSON",
    jsonInstructions: 'Istruzioni Formato JSON',
    jsonInstructionName: 'Il nome è obbligatorio e deve essere una stringa',
    jsonInstructionCategory:
      'CategoryId è obbligatorio e deve essere un numero',
    jsonInstructionCountry: 'CountryId è opzionale e deve essere un numero',
    jsonInstructionStatus: 'Lo stato deve essere uno tra',
    jsonInstructionTranslations:
      'Le traduzioni devono essere un record di codici lingua a oggetti di traduzione',
    jsonUpdateError: "Errore nell'aggiornamento di {{field}}: {{error}}",
    hideFilters: 'Nascondi Filtri',
    showFilters: 'Mostra Filtri',
    totalItems: '{{count}} elementi in totale',
    aiPrompt: {
      title: 'Genera Dati Alimenti con IA',
      description: "Usa l'IA per aiutare a generare dati degli alimenti",
      inputLabel: 'Nome Alimento',
      inputPlaceholder: 'Inserisci un nome di alimento',
      buttonText: 'Genera con IA',
      copyPrompt: 'Copia Prompt',
      openInChatGPT: 'Apri in ChatGPT',
      promptCopied: 'Prompt copiato negli appunti!',
      instructions: 'Istruzioni:',
      step1: '1. Inserisci un nome di alimento',
      step2: '2. Clicca su "Genera con IA" o copia il prompt',
      step3: '3. Incolla il prompt in ChatGPT o clicca su "Apri in ChatGPT"',
      step4:
        '4. Copia la risposta JSON e usala per creare un nuovo elemento alimento',
    },
  },
  languages: {
    en: 'Inglese',
    nl: 'Olandese',
    tr: 'Turco',
    de: 'Tedesco',
    fr: 'Francese',
    es: 'Spagnolo',
    it: 'Italiano',
    pt: 'Portoghese',
  },
};

export default managementTranslations;
